// Estado do Meu desempenho na URL: período, aba e os filtros da aba Ligações.
// O período (from/to) entra como filtro para que trocar de aba ou de página
// não o apague — o useTableSearch reescreve o search inteiro.
import {
  normalizeTableSearch,
  serializeTableSearch,
  type TableSearchConfig,
} from "./lib/table-search";
import { validateDateRangeSearch } from "./lib/date-range-search";

export const MY_PERFORMANCE_TABS = ["summary", "calls"] as const;
export type MyPerformanceTab = (typeof MY_PERFORMANCE_TABS)[number];

export const MY_PERFORMANCE_TABLE: TableSearchConfig = {
  filterKeys: ["from", "to", "q", "status"],
  extraKeys: ["tab"],
  sortFields: ["createdAt"],
  defaultSort: "createdAt",
  defaultSortDir: "desc",
  pageSizes: [25, 50, 100],
  defaultPageSize: 25,
};

export function parseMyPerformanceTab(raw: string | undefined): MyPerformanceTab {
  return MY_PERFORMANCE_TABS.includes(raw as MyPerformanceTab)
    ? (raw as MyPerformanceTab)
    : "summary";
}

export function validateMyPerformanceSearch(raw: Record<string, unknown>) {
  return {
    ...serializeTableSearch(normalizeTableSearch(raw, MY_PERFORMANCE_TABLE), MY_PERFORMANCE_TABLE),
    ...validateDateRangeSearch(raw),
  };
}
